export var CASE_DETAILS_STATE_NAME = 'index.customercare.customer.cases.detail';
export function routing($stateProvider) {
  $stateProvider.state(CASE_DETAILS_STATE_NAME, {
    url: '/detail/:caseId',
    template: '<customer-cases-detail></customer-cases-detail>'
  });
}